import React from "react";
import CreateDragWidthCom from "./index";
const { useCreateDragWidthCom } = CreateDragWidthCom;

/**
 * 判断是否存在store
 * @param {*} moduleId 
 * @returns 
 */
function getStore(moduleId) {
    if (this.dragWidthComDataSource && this.dragWidthComDataSource[moduleId]) {
        return this.dragWidthComDataSource[moduleId];
    } else {
        // console.warn('不存在createDragWidthComDataSource');
        // return null
        // 暂时通过error 提醒业务组、 稳定后可去掉
        throw Error(`正在调用ID为${moduleId}的左右侧拉容器的API, 但此左右侧拉容器还未通过use.createDragWidthCom注册,请先注册此ID，才能正常调用API`);
    }
}

/** 1   createDragWidthCom    创建左右侧拉容器**/
function createDragWidthCom(moduleId, config = {}) {
    let pageScope = this,
        currentStore = pageScope.dragWidthComDataSource[moduleId];
    if (!currentStore) {
        currentStore = useCreateDragWidthCom();
        pageScope.dragWidthComDataSource[moduleId] = currentStore;
    }
    return (
        <CreateDragWidthCom
            config={config}
            id={moduleId}
            store={currentStore}
            pageScope={pageScope}
        />
    );
}

/**
 * sideBox展开收起
 * @params id 创建dragWidthCom组件id
 * @params expandFlag true 展开 false 收起
 * @params callback 回调方法
 */
function expandSideBox(id, expandFlag, callback) {
    let currentStore = getStore.call(this, id);
    currentStore.setExpandFlag({ expandFlag, shouldForceUpdate: true, callback });
}

/**
 * sideBox展开收起
 * @params id 创建dragWidthCom组件id
 * @params callback 回调方法
 */
function toggleExpandSideBox(id, callback) {
    let currentStore = getStore.call(this, id);
    let expandFlag = currentStore.getExpandFlag();
    currentStore.setExpandFlag({ expandFlag: !expandFlag, shouldForceUpdate: true, callback });
}

/**
 * sideBox最大化
 * @params id 创建dragWidthCom组件id
 * @params maxFlag true 最大化 false 还原
 * @params callback 回调方法
 */
function maxSideBox(id, maxFlag, callback) {
    let currentStore = getStore.call(this, id);
    currentStore.setMaxFlag({ maxFlag, shouldForceUpdate: true, callback });
}

/**
 * sideBox最大化
 * @params id 创建dragWidthCom组件id
 * @params callback 回调方法
 */
function toggleMaxSideBox(id, callback) {
    let currentStore = getStore.call(this, id);
    let maxFlag = currentStore.getMaxFlag();
    currentStore.setMaxFlag({ maxFlag: !maxFlag, shouldForceUpdate: true, callback });
}

/**
 * sideBox tab切换
 * @params id 创建dragWidthCom组件id
 * @params tabActiveIndex 当前要激活的item的索引
 * @params callback 回调方法
 */
function changeSideTab(id, tabActiveIndex, callback) {
    let currentStore = getStore.call(this, id);
    let maxFlag = currentStore.getMaxFlag();
    // 最大化状态下不允许切换tabs
    if (maxFlag) {return;}
    currentStore.setTabActiveIndex({ tabActiveIndex, shouldForceUpdate: true, callback });
}

export { createDragWidthCom, expandSideBox, toggleExpandSideBox, maxSideBox, toggleMaxSideBox, changeSideTab };